module.exports = __webpack_public_path__ + "static/17-bigthief-476292af6ce66a951af1e91f379e7720.jpg";